export const clickOutside = {
  mounted(el, binding) {
    // Accept a function or an object { handler, events }
    const val = binding.value
    const handler = typeof val === 'function' ? val : val?.handler
    if (typeof handler !== 'function') return

    el._clickOutsideHandler = (event) => {
      if (!el.contains(event.target)) {
        handler(event)
      }
    }
    // Defer to avoid catching the click that triggered the mount
    setTimeout(() => {
      document.addEventListener('click', el._clickOutsideHandler, true)
    }, 0)
  },
  unmounted(el) {
    if (el._clickOutsideHandler) {
      document.removeEventListener('click', el._clickOutsideHandler, true)
      delete el._clickOutsideHandler
    }
  },
}
